import { Box, Text, useTheme } from "@chakra-ui/react";
import assets5gestar from "../../../innerAsstes/imagenes hero y modulo curso/Asset 5gestar.png";
import React from "react";
import ButtonMore from "../../buttonMore/buttonMore";
import { Link } from "react-router-dom";
import { useAppContext } from "../../../App";

export default function SlideCarouselLittle({
  imgSrc = assets5gestar,
  period="",
  modes=[],
  cardTitle,
  isNew = true,
  cardType = "CURSO",
  cardDescription,
  showButtonMore = true,
  buttonRedirectTo = '',
  additionalActionsForButton = () => null,
  customStyles = {}
}) {
  const theme = useTheme();
  const { isMobile } = useAppContext();
  const style = styles(theme, isMobile, customStyles, cardType);
  const descriptionToShow = cardDescription.length > 60  && isMobile ? cardDescription.slice(0, 60).concat('...') : cardDescription;
  
  return (
    <div style={style.container} className="sansation-bold">
      <div style={style.cardHeader}>
        <div style={style.firstBadge}>{cardType}</div>
{/* {isNew && <div style={style.badgeNew}>NUEVO</div>} */}
      </div>
      <div style={style.titleAndImgContainer}>
  <Link to={buttonRedirectTo} style={{ width: isMobile ? "100%" : "70%", textDecoration: "none", color: "inherit" }}>
    <p style={style.title}>{cardTitle}</p>
  </Link>
  <img style={style.img} src={imgSrc} alt="img card" />
</div>
      <p style={style.description}>{descriptionToShow}</p>
      { showButtonMore && 
      <ButtonMore 
        buttonText="MÁS INFO" 
        customStyles={style.buttonStyles} 
        redirectTo={buttonRedirectTo}
        customActionsOnCLick={additionalActionsForButton}
      />}
      { !showButtonMore && 
        <Box
          as="div"
          style={style.cardFooter}
          display={'flex'}
          justifyContent={'center'}
          alignContent={'center'}
        >
          <Box as="div" style={style.textDiv}>
            <Text {...style.textFooter('secondary')}>
              DURACIÓN
            </Text>
            <Text {...style.textFooter('tertiary')}>
              {period}
            </Text>
          </Box>
          <Box as="div" style={{...style.textDiv, width: isMobile? '100%':'70%'}}>
            <Text {...style.textFooter('secondary')}>
              MODALIDAD
            </Text>
            <Text {...style.textFooter('tertiary')}>
              {modes.length !== 0? modes.join('/') : "asincronico*"}
            </Text>
          </Box>
          <Box as="div" style={style.inscriptionBtn}>
  <Link to={buttonRedirectTo} style={{ width: "100%" }}>
    Solicitar Información
  </Link>
</Box>
        </Box>
      }
    </div>
  );
}

const styles = (theme, isMobile, customStyles,cardType) => ({
  container: {
    display: "flex",
    flexDirection:"column",
    justifyContent:"space-between",
    borderRadius: 10,
    padding: 20,
    marginLeft: '2%',
    marginRight: '2%',
    minHeight: '35vh',
    alignItems: 'space-between',
    backgroundColor: 'white',
    background: theme.background.quaternary,
    ...customStyles.container,
  },
  cardHeader: {
    display: "flex",
    flexDirection: isMobile? 'column': 'row',
    justifyContent: "space-between",
    ...customStyles.cardHeader,
  },
  firstBadge: {
    padding: 2,
    paddingLeft: 10,
    paddingRight:  10,
    backgroundColor: cardType === 'CURSO'? "purple" : theme.background.tertiary,
    color: theme.color.text.primary,
  },
  badgeNew: {
    padding: 2,
    paddingLeft: 10,
    paddingRight:  10,
    color: theme.color.text.primary,
    backgroundColor: theme.background.secondary,
  },
  titleAndImgContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: '1rem',
    marginBottom: '0.5rem',
    ...customStyles.titleAndImgContainer,
  },
title: {
  fontSize: isMobile ? "clamp(1rem, 3vw, 1.2rem)" : "clamp(0.1rem, 2vw, 1rem)", // Más pequeño y adaptable
  width: isMobile ? "100%" : "60%",
  lineHeight: 1.1,
  color: theme.color.text.tertiary,
  maxHeight: "18em", // Permite hasta 3 líneas aprox.
  overflow: "visible",
  textOverflow: "unset",
  display: "-webkit-box",
  WebkitLineClamp: "unset",
  WebkitBoxOrient: "vertical",
  ...customStyles.title,
},
description: {
  fontSize: isMobile ? "clamp(1rem, 3vw, 1.2rem)" : "clamp(0.5rem, 2vw, 0.8rem)", // Más pequeño y adaptable
  textAlign: "justify",
  marginBottom: 10,
  lineHeight: 1.2,
  maxHeight: "3.6em", // Limita a 3 líneas aprox.
  overflow: "hidden",
  textOverflow: "ellipsis",
  display: "-webkit-box",
  WebkitLineClamp: 3,
  WebkitBoxOrient: "vertical"
},
  img: {
    width: "30%",
    ...customStyles.img,
  },
  buttonStyles: {
    container: {
      width: isMobile? "100%":"60%",
      padding: "0.5rem",
      justifyContent: "space-around",
      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.6)",
    },
    text: {
      fontSize: "1.2rem",
      width: "auto",
    },
    arrowSvg: {
      height: "100%",
    },
  },
  cardFooter: {
    display: "flex",
    flexDirection: "row",
      alignItems: "stretch", // Asegura que todos los hijos tengan el mismo alto

    ...customStyles.cardFooter
  },
  textFooter: (myColor) => ({
    fontSize: isMobile ? "clamp(1rem, 1.5vw, 1.2rem)" : "clamp(0.3rem, 1vw, 0.8rem)",
    lineHeight: 1.2,
    color: theme.color.text[myColor]
  }),
  textDiv: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    textAlign: "center",
    paddingRight: "2%",
    paddingLeft: "2%",
    width: "30%",
    flex: 1, // <-- Nuevo: que ocupe el mismo espacio que los otros
    borderRight: "1px solid",
    borderRightColor: theme.color.text.tertiary,
    ...customStyles.textDiv
  },
  inscriptionBtn: {
  fontSize: isMobile ? "clamp(1rem, 1.5vw, 1.2rem)" : "clamp(0.3rem, 1vw, 0.8rem)",
  display: "flex",
  alignItems: "center", // <-- Centra verticalmente el contenido
  justifyContent: "center",
  flex: 1, // <-- Nuevo: que ocupe el mismo espacio que los otros
  height: "100%", // <-- Asegura que ocupe todo el alto del footer

  paddingRight: "2%",
  paddingLeft: "2%",
  flexWrap: 'wrap',
  whiteSpace: 'wrap',
  textAlign: "center",
  borderRadius: 0,
  color: theme.color.text.primary,
  backgroundColor: theme.background.tertiary,
  ...customStyles.slideButton
}
});
